import { useState } from 'react';
import { faqList } from '@/mocks/nav';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section
      id="faq"
      className="scroll-mt-20 border-b border-background-200 bg-background-50 py-14 md:scroll-mt-24 md:py-20"
    >
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-accent-700 md:text-sm">
              <i className="ri-question-answer-line text-base" aria-hidden="true"></i>
              FAQ
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">常见问题</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              关于入口收录、地址失效、反馈方式等问题，这里给出了最直接的答案。还有疑问可以在底部反馈表留言。
            </p>
            <a
              href="#contact"
              className="mt-5 inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50"
            >
              去提问
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </div>

          <div className="lg:col-span-8">
            <ul className="flex flex-col gap-3">
              {faqList.map((item, index) => {
                const open = openIndex === index;
                return (
                  <li key={item.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
                    <button
                      type="button"
                      onClick={() => setOpenIndex(open ? -1 : index)}
                      aria-expanded={open}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-200/60"
                    >
                      <span className="flex items-center gap-3">
                        <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-primary-100 font-heading text-xs font-bold text-primary-700">
                          {index + 1}
                        </span>
                        <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">{item.q}</span>
                      </span>
                      <span
                        className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-md text-xl transition-colors ${
                          open ? 'bg-primary-500 text-background-50' : 'bg-background-50 text-foreground-600'
                        }`}
                      >
                        <i className={open ? 'ri-subtract-line' : 'ri-add-line'} aria-hidden="true"></i>
                      </span>
                    </button>
                    {open && (
                      <div className="border-t border-background-200 py-4 pl-5 pr-5 md:pl-16">
                        <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}